import { render } from "./unverifiedFooter.vue?vue&type=template&id=0ca6fa50&scoped=true"
import script from "./unverifiedFooter.vue?vue&type=script&lang=js"
export * from "./unverifiedFooter.vue?vue&type=script&lang=js"

import "./unverifiedFooter.vue?vue&type=style&index=0&id=0ca6fa50&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca6fa50"]])

export default __exports__